module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo",
    class: _vm.collapsed ? 'logo-collapse-width' : 'logo-width',
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n        " + _vm._s(_vm.collapsed ? '' : _vm.sysName) + "\n      ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "25px",
      "margin-left": "10px"
    },
    attrs: {
      "id": "center-bottom-board"
    }
  }, [_c('marquee-scroll', {
    attrs: {
      "duration": 5000
    }
  }, [_c('img', {
    staticClass: "png-image",
    attrs: {
      "src": require("../assets/notice1.png"),
      "alt": "PNG"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.items[0]))])])], 1)]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "message-icon",
    on: {
      "click": _vm.showMessagess
    }
  }, [(_vm.unreadMessages.length > 0) ? _c('div', {
    staticClass: "icon-wrapper"
  }, [_c('i', {
    staticClass: "el-icon-chat-line-round"
  }), _vm._v(" "), _c('span', {
    staticClass: "red-dot"
  })]) : _c('i', {
    staticClass: "el-icon-chat-round",
    staticStyle: {
      "font-size": "25px"
    }
  })]), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "trigger": "hover",
      "placement": "bottom-end"
    }
  }, [_c('div', {
    staticClass: "userinfo-inner el-dropdown-link"
  }, [_c('div', {
    staticClass: "name-wrapper"
  }, [_vm._v(_vm._s(_vm.sysUserName))]), _vm._v(" "), _c('div', {
    staticClass: "avatar-wrapper"
  }, [_c('img', {
    class: {
      shake: _vm.isNewMessage
    },
    attrs: {
      "src": _vm.sysUserAvatar || _vm.defaultAvatar
    }
  })])]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "messages"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showMessagess($event)
      }
    }
  }, [_vm._v("\n              我的消息\n              "), (_vm.unreadMessages.length > 0) ? _c('el-badge', {
    attrs: {
      "value": _vm.unreadMessages.length
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.setup($event)
      }
    }
  }, [_vm._v("个人中心")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.logout($event)
      }
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    class: _vm.collapsed ? 'menu-collapsed' : 'menu-expanded'
  }, [_c('el-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }],
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "unique-opened": "",
      "router": ""
    },
    on: {
      "open": _vm.handleopen,
      "close": _vm.handleclose,
      "select": _vm.handleselect
    }
  }, [_vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? [(!item.leaf) ? _c('el-submenu', {
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('el-menu-item', {
        key: child.path,
        attrs: {
          "index": child.path
        }
      }, [_vm._v("\n                " + _vm._s(child.name) + "\n              ")]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (item.leaf && item.children.length > 0) ? _c('el-menu-item', {
      attrs: {
        "index": item.children[0].path
      }
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.children[0].name) + "\n            ")]) : _vm._e()] : _vm._e()
  })], 2), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collapsed),
      expression: "collapsed"
    }],
    ref: "menuCollapsed",
    staticClass: "el-menu el-menu-vertical-demo collapsed"
  }, _vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? _c('li', {
      staticClass: "el-submenu item"
    }, [(!item.leaf) ? [_c('div', {
      staticClass: "el-submenu__title",
      staticStyle: {
        "padding-left": "20px"
      },
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })]), _vm._v(" "), _c('ul', {
      staticClass: "el-menu submenu",
      class: 'submenu-hook-' + index,
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('li', {
        key: child.path,
        staticClass: "el-menu-item",
        class: _vm.$route.path == child.path ? 'is-active' : '',
        staticStyle: {
          "padding-left": "40px"
        },
        on: {
          "click": function($event) {
            return _vm.$router.push(child.path)
          }
        }
      }, [_vm._v(_vm._s(child.name) + "\n                ")]) : _vm._e()
    }), 0)] : [_c('ul', [_c('li', {
      staticClass: "el-submenu"
    }, [_c('div', {
      staticClass: "el-submenu__title el-menu-item",
      class: _vm.$route.path == item.children[0].path ? 'is-active' : '',
      staticStyle: {
        "padding-left": "20px",
        "height": "56px",
        "line-height": "56px",
        "padding": "0 20px"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push(item.children[0].path)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })])])])]], 2) : _vm._e()
  }), 0)], 1), _vm._v(" "), _c('div', {
    ref: "historyTaskbar",
    staticClass: "history-taskbar"
  }, [_c('transition-group', {
    staticClass: "history-taskbar-container",
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, _vm._l((_vm.filteredHistoryTaskbar), function(item, index) {
    return _c('el-tag', {
      key: item.path,
      staticClass: "history-item",
      style: (_vm.$route.path === item.path ? 'padding-left: 25px; position: relative;' : 'padding-left: 10px; position: relative;'),
      attrs: {
        "closable": true,
        "type": _vm.$route.path === item.path ? 'primary' : 'info',
        "effect": _vm.$route.path === item.path ? 'dark' : null
      },
      on: {
        "close": function($event) {
          return _vm.removeFromHistory(index)
        },
        "click": function($event) {
          return _vm.navigateToPage(item.path)
        }
      }
    }, [(_vm.$route.path === item.path) ? _c('span', {
      staticClass: "dot"
    }) : _vm._e(), _vm._v("\n            " + _vm._s(item.name) + "\n          ")])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "right_body main-container"
  }, [_c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24
    }
  }, [_c('strong', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$route.name))]), _vm._v(" "), _c('el-breadcrumb', {
    staticClass: "breadcrumb-inner",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.$route.matched), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [_vm._v("\n                  " + _vm._s(item.name) + "\n                ")])
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('keep-alive', {
    attrs: {
      "include": _vm.$store.state.cache.cachedViews
    }
  }, [_c('router-view')], 1)], 1)], 1)], 1)])])])], 1), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "visible": _vm.drawerVisible,
      "size": "30%",
      "direction": "rtl",
      "with-header": false
    },
    on: {
      "update:visible": function($event) {
        _vm.drawerVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "drawer-header"
  }, [_c('h3', {
    staticClass: "drawer-title"
  }, [_vm._v("消息中心")]), _vm._v(" "), (_vm.messages.length > 0) ? _c('div', {
    staticClass: "clear-all-button"
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "size": "mini"
    },
    on: {
      "click": _vm.clearAllMessages
    }
  }, [_vm._v("\n          清空所有消息\n        ")])], 1) : _vm._e()]), _vm._v(" "), (_vm.messages.length > 0) ? _c('div', _vm._l((_vm.messages), function(message, index) {
    return _c('div', {
      key: index,
      staticClass: "message-container"
    }, [_c('p', {
      staticClass: "message-time"
    }, [_vm._v(_vm._s(message.infoTime))]), _vm._v(" "), _c('el-card', {
      staticClass: "message-card",
      attrs: {
        "body-style": {
          padding: '20px'
        }
      }
    }, [_c('el-button', {
      staticClass: "delete-button",
      attrs: {
        "type": "text",
        "size": "mini",
        "icon": "el-icon-delete"
      },
      on: {
        "click": function($event) {
          return _vm.deleteMessage(message.id)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "message-content-wrapper"
    }, [_c('el-tag', {
      staticClass: "message-tag",
      attrs: {
        "type": "success"
      }
    }, [_vm._v(_vm._s(message.infoType))]), _vm._v(" "), _c('p', {
      staticClass: "message-content"
    }, [_vm._v(_vm._s(message.infoContent))])], 1)], 1)], 1)
  }), 0) : _c('div', [_c('el-empty', {
    attrs: {
      "description": "当前没有消息"
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-789d6906"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 1022
// module chunks = 3